'use client';
import React from 'react';
import { motion } from 'framer-motion';
import { InView } from 'react-intersection-observer';

interface AnimatedProps {
  classList?: string;
  children: React.ReactNode;
  reverse?: boolean;
  delay?: number;
  vertical?: boolean;
}

const Animated = ({
  classList = '',
  children,
  reverse,
  delay,
  vertical,
}: AnimatedProps) => {
  const variants = {
    hidden: {
      opacity: 0,
      translateY: vertical ? '-15%' : 0,
      translateX: !vertical ? (reverse ? '-15%' : '15%') : 0,
    },
    visible: {
      opacity: 1,
      translateY: 0,
      translateX: 0,
      transition: {
        opacity: { duration: 1, delay },
        translateY: { duration: 0.3, delay },
        translateX: { duration: 0.3, delay },
      },
    },
  };

  return (
    <InView threshold={0.3}>
      {({ ref, inView }) => (
        <motion.div
          ref={ref}
          variants={variants}
          initial={'hidden'}
          animate={inView ? 'visible' : 'hidden'}
          className={classList}
        >
          {children}
        </motion.div>
      )}
    </InView>
  );
};

export default Animated;
